import { DatosAspiranteModel } from './datos-aspirante.model';

export class InformacionEconomicaModel {
  NivelEstudios: string = '';
  RelacionLaboral: string = '';
  ActividadEconomica: string = '';
  FechaIngresoLaboralActual!: Date;
  FechaJubilacion!: Date;
  FechaInicioNegocio!: Date;
  MontoIngresosMensuales!: number;
  MontoVentasAnuales!: number;
  MontoEgresosMensuales!: number;
  MontoTotalActivos!: number;
  MontoTotalPasivos!: number;
  TieneOtrosIngresos!: boolean;
  MontoOtrosIngresos!: number;
  FuenteOtrosIngresos!: string;

  clear() {
    this.NivelEstudios = '';
    this.RelacionLaboral = '';
    this.ActividadEconomica = '';
    this.FechaIngresoLaboralActual = new Date();
    this.FechaJubilacion = new Date();
    this.FechaInicioNegocio = new Date();
    this.MontoIngresosMensuales = 0;
    this.MontoVentasAnuales = 0;
    this.MontoEgresosMensuales = 0;
    this.MontoTotalActivos = 0;
    this.MontoTotalPasivos = 0;
    this.TieneOtrosIngresos = false;
    this.MontoOtrosIngresos = 0;
    this.FuenteOtrosIngresos = '';
  }
}
